// Vouvoiement d'un compte partenaire (D-037, D-103). Un compte partenaire seul — ni fiche au club, ni enfant, ni
// bureau, ni équipe à entraîner — est une entreprise : on la vouvoie partout, y compris quand elle sort de son
// espace (Avantages, Inviter, Trouver un partenaire, Notifications, Aide, la casquette Bénévole d'un partenaire
// aussi bénévole, D-071, Mes badges). Les membres du club, eux, sont tutoyés (D-101).
import type { Ctx } from './context';

/** Le compte est-il un partenaire seul (il peut être aussi bénévole) ? */
export const vouvoie = (c: Ctx): boolean => c.partners.length > 0 && !c.full.people.length && !c.full.adminOf.length && !c.full.coachOf.size;

/** Le texte au tutoiement, ou au vouvoiement pour un compte partenaire seul. */
export const tv = (c: Ctx, tu: string, vous: string): string => (vouvoie(c) ? vous : tu);
